import { useWallets } from '@mysten/dapp-kit-react'
import { normalizeSuiAddress } from '@mysten/sui/utils'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

import { useCurrentWalletAddress } from './useCurrentWalletAddress'
import { useViewAsWallet } from 'contexts/ViewAsWalletContext'

export const usePostHogWalletIdentify = () => {
  const walletAddress = useCurrentWalletAddress()
  const wallets = useWallets()
  const { viewAsWalletAddress } = useViewAsWallet()

  const posthog = usePostHog()

  useEffect(() => {
    if (
      !walletAddress ||
      import.meta.env.MODE !== 'production' ||
      !posthog ||
      // Don't initialize posthog when debug mode is on
      viewAsWalletAddress
    ) {
      return
    }

    const allAddresses = new Set<string>()
    for (const wallet of wallets) {
      for (const account of wallet.accounts) {
        allAddresses.add(normalizeSuiAddress(account.address))
      }
    }

    posthog.identify(walletAddress, {
      wallet_addresses: Array.from(allAddresses),
    })

    // Reload feature flags after identifying user so user-targeted flags are evaluated correctly
    posthog.reloadFeatureFlags()
  }, [walletAddress, posthog, wallets, viewAsWalletAddress])
}
